import { useMutation } from '@apollo/client';
import {
  CreateTerminalPaymentResponse,
  PaymentMethod,
} from '@/api/types/payments.types';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { CREATE_TERMINAL_PAYMENT } from '@/api/mutations/payments.mutations';

export function useTerminalPayment({
  defaultOpenState,
  payment,
}: {
  defaultOpenState?: boolean;
  payment: PaymentMethod;
}) {
  const [isTerminalOpen, toggleTerminal] = useToggleOpenState(defaultOpenState);

  const isTerminal = payment === PaymentMethod.Terminal;

  const [createTerminalPayment, { loading: isCreateTerminalPaymentLoading }] =
    useMutation<CreateTerminalPaymentResponse>(CREATE_TERMINAL_PAYMENT, {
      onCompleted: data => {
        if (data.createTerminalPayment.entity) {
          toggleTerminal();
        }
      },
    });

  return {
    isTerminalOpen,
    toggleTerminal,
    isTerminal,
    createTerminalPayment,
    isCreateTerminalPaymentLoading,
  };
}
